import './stay.css';

// Trip "Stay" tab — shows the optional accommodation name, location, a short
// description and its images.
const safeMapLink = (url) => {
    const u = String(url || '').trim();
    return /^https?:\/\//i.test(u) ? u : '';
};

export default function Stay({ data }) {
    const stay = data || {};
    const images = (stay.images || []).filter(Boolean);
    const mapLink = safeMapLink(stay.mapLink);

    return (
        <div className='stayTab'>
            {(stay.name || stay.location || mapLink) && (
                <div className='stayTabHead'>
                    {stay.name && <h3 className='stayTabName'>{stay.name}</h3>}
                    {stay.location && (
                        <div className='stayTabLoc'>
                            <svg viewBox='0 0 24 24' width='15' height='15' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
                                <path d='M21 10c0 6-9 12-9 12s-9-6-9-12a9 9 0 0 1 18 0z' />
                                <circle cx='12' cy='10' r='3' />
                            </svg>
                            <span>{stay.location}</span>
                        </div>
                    )}
                    {mapLink && (
                        <a className='stayTabMap' href={mapLink} target='_blank' rel='noreferrer'>
                            <svg viewBox='0 0 24 24' width='15' height='15' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
                                <path d='M21 10c0 6-9 12-9 12s-9-6-9-12a9 9 0 0 1 18 0z' />
                                <circle cx='12' cy='10' r='3' />
                            </svg>
                            View on map
                        </a>
                    )}
                </div>
            )}

            {stay.description && <p className='stayTabDesc'>{stay.description}</p>}

            {images.length > 0 && (
                <div className='stayTabImages'>
                    {images.map((url, i) => (
                        <a href={url} target='_blank' rel='noreferrer' className='stayTabImg' key={i}>
                            <img src={url} alt={`${stay.name || 'Stay'} ${i + 1}`} loading='lazy' />
                        </a>
                    ))}
                </div>
            )}

            {!stay.name && !stay.location && !stay.description && images.length === 0 && (
                <p className='stayTabEmpty'>No stay details added.</p>
            )}
        </div>
    );
}
